import React, { useRef } from "react";

const FileUploader = ({ onFileSelectSuccess, onFileSelectError }) => {
  const fileInput = useRef(null);

  const handleFileInput = e => {
    // handle validations
    const file = e.target.files[0];
    if (file.size > 1024000) onFileSelectError({ error: "File size cannot exceed more than 1MB" });
    else onFileSelectSuccess(file);

    console.log(file.size);
  };

  return (
    <input type="file" name="file" onChange={handleFileInput} />
    // {/* <button onClick={e => fileInput.current && fileInput.current.click()} className="btn btn-primary" >HI</button> */}
  );
};

export default FileUploader;
